import React, { useContext, useEffect } from 'react';
// import BlockHome from '../pagesHome2/BlockHome';
// import CemeteryHome from '../pagesHome2/CemeteryHome';
import { Card, Typography } from '@mui/material';
import { GlobalContext } from '../../../App';
import { TemplateContext } from '../pagesMains/GravesManagers/Graves';
// import PlotHome from '../pagesHome2/PlotHome';
// import AreaGraveHome from '../pagesHome2/AreaGraveHome';
// import PurchasesHome from '../pagesHome2/PurchasesHome';
// import BurialsHome from '../pagesHome2/BurialsHome';
// import CustomersHome from '../pagesHome2/CustomersHome';
import { useSelector } from 'react-redux';

const GlobalSearchDashboard = () => {
  const recordsOptions = useSelector((state) => state.recordsOptions.data);
  const { permission, setBackgroundColor } = useContext(GlobalContext);
  const { selectedFilters } = useContext(TemplateContext); // קבלת ה- selectedFilters מ- TemplateContext

  useEffect(() => {
    setBackgroundColor('transparent'); // הגדרת רקע שקוף עבור הקומפוננטה
    return () => setBackgroundColor('white'); // הגדרת רקע ברירת מחדל כאשר הקומפוננטה מתנתקת
  }, [setBackgroundColor]);

  return (
    <div style={{ backgroundColor: 'transparent' }}>
      {recordsOptions?.map((record, index) => {
        // דילוג על הרשומה עם אינדקס 0
        if (index === 0) return null;

        if (permission === 0 || record?.permissions?.includes(permission)) {
          return (
            (selectedFilters.includes(0) ||
              selectedFilters.includes(index)) && (
              <Card sx={{ backgroundColor: 'white', mb: 2 }}>
                <Typography variant="h5" align="right" sx={{ mb: 2, ml: 2 }}>
                  {record.label}
                </Typography>
                {record.component}
              </Card>
            )
          );
        }
      })}
      {/* {(selectedFilters.includes(0) || selectedFilters.includes(1)) && (
    <Card sx={{ backgroundColor: 'white', mb: 2 }}>
     <Typography variant="h5" align="right" sx={{ mb: 2, ml: 2 }}>
      בתי עלמין
     </Typography>
     <CemeteryHome />
    </Card>
   )}
   {(selectedFilters.includes(0) || selectedFilters.includes(2)) && (
    <Card sx={{ backgroundColor: 'white', mb: 2 }}>
     <Typography variant="h5" align="right" sx={{ mb: 2, ml: 2 }}>
      גושים
     </Typography>
     <BlockHome />
    </Card>
   )}
   {(selectedFilters.includes(0) || selectedFilters.includes(3)) && (
    <Card sx={{ backgroundColor: 'white', mb: 2 }}>
     <Typography variant="h5" align="right" sx={{ mb: 2, ml: 2 }}>
      חלקות
     </Typography>
     <PlotHome />
    </Card>
   )}
   {(selectedFilters.includes(0) || selectedFilters.includes(4)) && (
    <Card sx={{ backgroundColor: 'white', mb: 2 }}>
     <Typography variant="h5" align="right" sx={{ mb: 2, ml: 2 }}>
      קברים
     </Typography>
     <AreaGraveHome />
    </Card>
   )}
   {(selectedFilters.includes(0) || selectedFilters.includes(5)) && (
    <Card sx={{ backgroundColor: 'white', mb: 2 }}>
     <Typography variant="h5" align="right" sx={{ mb: 2, ml: 2 }}>
      רכישות
     </Typography>
     <PurchasesHome />
    </Card>
   )}
   {(selectedFilters.includes(0) || selectedFilters.includes(6)) && (
    <Card sx={{ backgroundColor: 'white', mb: 2 }}>
     <Typography variant="h5" align="right" sx={{ mb: 2, ml: 2 }}>
      קבורות
     </Typography>
     <BurialsHome />
    </Card>
   )}
   {(selectedFilters.includes(0) || selectedFilters.includes(7)) && (
    <Card sx={{ backgroundColor: 'white', mb: 2 }}>
     <Typography variant="h5" align="right" sx={{ mb: 2, ml: 2 }}>
      לקוחות
     </Typography>
     <CustomersHome />
    </Card>
   )} */}
      {/* הוספת קומפוננטות נוספות בהתאם ל-selectedFilters */}
    </div>
  );
};

export default GlobalSearchDashboard;
